import PropTypes from 'prop-types';
import React from 'react';

const LikesCommentsSection = ({likes, replies, renderForPdf}) => {
    const likesCount = renderForPdf ? `${likes} likes` : `${likes}`;
    const repliesCount = renderForPdf ? `${replies} comments` : `${replies}`;

    return (
        <div className="post-metric likes-comments">
            <div className="post-likes">
                <i className="fa fa-heart-o" />
                {likesCount}
            </div>
            <div className="post-comments">
                <i className="fa fa-comment-o" />
                {repliesCount}
            </div>
        </div>
    );
};

LikesCommentsSection.propTypes = {
    likes: PropTypes.number.isRequired,
    replies: PropTypes.number.isRequired
};

export default LikesCommentsSection;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/post_grid_item/likes_comments_section.js